// import React from "react";
// import { Scrollbars } from "react-custom-scrollbars-2";
// import { Card, CardBody } from "@windmill/react-ui";
// import useStaffSubmit from "hooks/useStaffSubmit";
// import Title from "components/form/Title";
// import LabelArea from "components/form/LabelArea";
// import InputName from "components/form/InputName";
// import InputValue from "components/form/InputValue";
// import InputArea from "components/form/InputArea";
// import Error from "components/form/Error";
// import SelectRole from "components/form/SelectRole";
// import DrawerButton from "components/form/DrawerButton";
// import SelectState from "components/form/SelectStaffState";

// const StaffDrawer = ({ id }) => {

//   const {
//     trigger,
//     register,
//     handleSubmit,
//     selectedState,
//     setSelectedState,
//     onSubmit,
//     loading,
//     errors,
//   } = useStaffSubmit(id);
// // console.log(selectedState)
//   return (
//     <>
//       <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
//         {id ? (
//           <Title register={register} title="Edit User" />
//         ) : (
//           <Title register={register} title="Add User" />
//         )}
//       </div>
//       <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
//         <Card
//           className="flex-grow scrollbar-hide w-full max-h-full"
//           style={{ overflow: "visible" }}
//         >
//           <CardBody>
//             <form onSubmit={handleSubmit(onSubmit)}>
//               <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
//                 <div
//                   className="grid grid-cols-12 gap-y-6 gap-x-5 mb-6 items-center"
//                   style={{ gridAutoRows: "auto" }}
//                 >
//                   <div className="col-span-6">
                  
//                     <LabelArea required label="Name" />
//                     <InputName
//                       trigger={trigger}
//                       register={register}
//                       label="Name"
//                       name="name"
//                       type="text"
//                       placeholder="Jhon"
//                       pattern={/^[a-zA-Z]+$/}
//                     />
//                     <Error errorName={errors.name} />
//                   </div>


//                   <div className="col-span-6">
//                     <LabelArea required label="Email" />
//                     <InputValue
//                       trigger={trigger}
//                       register={register}
//                       label="Email"
//                       name="email"
//                       type="text"
//                       pattern={
//                         /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
//                       }
//                       placeholder="jhon@gmail.com"
//                     />
//                     <Error errorName={errors.email} />
//                   </div>

//                  {!id ? <div className="col-span-6">
//                     <LabelArea required label="Password" />
//                     <InputArea
//                       trigger={trigger}
//                       register={register}
//                       label="Password"
//                       name="password_update"
//                       type="text"
//                       placeholder="***********"
//                     />

//                     <Error errorName={errors.password_update} />
//                   </div> : null} 

                  

//                   <div className="col-span-6">
//                     <LabelArea required label="Employee Role" />
//                     <SelectRole
//                       register={register}
//                       label="Employee Role"
//                       name="id_profile"
//                     />
//                     <Error errorName={errors.id_profile} />
//                   </div>

//                   <div className="col-span-6 mt-10">
//                     <LabelArea required label="Select State" />
//                     <SelectState
//                       onSelectState={setSelectedState}
//                       register={register}
//                       name="state"
//                       required={false}
//                       selectedServiceState={selectedState}
//                       setSelectedServiceState={setSelectedState}
//                       showClearAllButton={true}
//                     />

//                     <Error errorName={errors.state} />
//                   </div>

                  
//                 </div>
//               </div>

//               <DrawerButton id={id} isSubmitting={loading} />
//             </form>
//           </CardBody>
//         </Card>
//       </Scrollbars>
//     </>
//   );
// };

// export default StaffDrawer;



import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import useStaffSubmit from "hooks/useStaffSubmit";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputName from "components/form/InputName";
import InputValue from "components/form/InputValue";
import InputArea from "components/form/InputArea";
import Error from "components/form/Error";
import SelectRole from "components/form/SelectRole";
import DrawerButton from "components/form/DrawerButton";
import SelectState from "components/form/SelectStaffState";

const StaffDrawer = ({ id }) => {
  const {
    trigger,
    register,
    handleSubmit,
    selectedState,
    setSelectedState,
    onSubmit,
    loading,
    errors,
  } = useStaffSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title
          register={register}
          title={id ? "Edit User" : "Add User"}
        />
      </div>

      <Scrollbars
        className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200"
        style={{ height: "calc(100vh - 80px)" }}
      >
        <Card
          className="flex-grow scrollbar-hide w-full max-h-full"
          style={{ overflow: "visible" }}
        >
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div
                  className="grid grid-cols-12 gap-y-6 gap-x-5 mb-6 items-center"
                  style={{ gridAutoRows: "auto" }}
                >
                  <div className="col-span-6">
                    <LabelArea required label="Name" />

                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Name"
                      name="name"
                      type="text"
                      placeholder="Jhon"
                      pattern={/^[a-zA-Z]+$/}
                      disabled={!!id}
                    />

                    <Error errorName={errors.name} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Email" />

                    <InputValue
                      trigger={trigger}
                      register={register}
                      label="Email"
                      name="email"
                      type="email"
                      placeholder="jhon@gmail.com"
                      pattern={
                        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                      }
                       disabled={!!id}
                    />

                    <Error errorName={errors.email} />
                  </div>

                  {!id && (
                    <div className="col-span-6">
                      <LabelArea required label="Password" />

                      <InputArea
                        trigger={trigger}
                        register={register}
                        label="Password"
                        name="password_update"
                        type="password"
                        placeholder="***********"
                      />

                      <Error errorName={errors.password_update} />
                    </div>
                  )}

                  <div className="col-span-6">
                    <LabelArea required label="Employee Role" />

                    <SelectRole
                      register={register}
                      label="Employee Role"
                      name="id_profile"
                    />

                    <Error errorName={errors.id_profile} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Select State" />

                    <SelectState
                      onSelectState={setSelectedState}
                      register={register}
                      name="state"
                      required={false}
                      selectedServiceState={selectedState}
                      setSelectedServiceState={setSelectedState}
                      showClearAllButton={true}
                    />

                    <Error errorName={errors.state} />
                  </div>
                </div>
              </div>

              <DrawerButton
                id={id}
                isSubmitting={loading}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default StaffDrawer;